import ActionAbstract from '../ActionAbstract';
import * as helper from '../../helper';

class HistoryBack extends ActionAbstract {

    static get ID() {
        return 'actions:main:historyBack';
    }

    run(state) {
        
        let history = ( state.breadcrumb && state.breadcrumb.history ) ? state.breadcrumb.history : [];
        let crtHistory = ( state.breadcrumb && state.breadcrumb.crtHistory ) ? state.breadcrumb.crtHistory : 0 ;

        crtHistory++;
        if( crtHistory > state.breadcrumb.history.length-1 )
            crtHistory = state.breadcrumb.history.length-1;

        let target = state.breadcrumb.history[crtHistory];

        this.trigger('editor:openEditor', { id : target, openFromHistory: true } );
        
        return this.composeState( state, {
            breadcrumb : {
                crtHistory : crtHistory
            }
        })
    }

}

export default HistoryBack;